import { DEFAULT_LOCATIONS, EMBOLD, CHECKMARK } from 'utils/constants';
import { selectToken } from 'utils/selectToken';
import emboldLogo from 'assets/embold-icon.png';
import emboldLoginLogo from 'assets/embold-login-logo.svg';

export const apiTokens = {
  dev: 'Token 4545d3e11a2b6a9591a3264693175ee3ce9a1e04',
  staging: 'Token b100d0637af11c6e960cef89c71c03a488201e9c',
  prod: 'Token d3d2ac680a2fba072de7cb9b969be3c13ece59f6',
};

const token = selectToken(apiTokens);

const emboldConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'embold',

  API_TOKEN: token,
  EMBOLD_CLIENT: EMBOLD,
  EMBOLD_CLIENT_SLUG: 'embold',

  // login
  SHOW_REGION_SELECTOR: false,

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Nashville },
  LOGIN_NETWORK_NAME: 'emboldUserId',

  // content
  DISPLAY_NAME: 'Embold Health',
  HEADER_LOGO: emboldLogo,
  EMBOLD_LOGO_PRESENT: false,
  LOCAL_LOGO_ASSET: emboldLoginLogo,
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: false,
};

export default emboldConfig;
